export const CHOOSE_REGION_PATH = "/choose-region";
export const DARK_MODE_GATING_PATH = "/unlock-dark-mode";
